import {createStandardAction} from 'typesafe-actions'
import {ControllerConnectionState} from '../../model/controller/ControllerConnectionState'

export const controllerConnectionStateChanged =
  createStandardAction('controller/controllerConnectionStateChanged')<{ connectionState: ControllerConnectionState }>()
export const connectController = createStandardAction('controller/connectController')<void>()
export const disconnectController = createStandardAction('controller/disconnectController')<void>()
export const magicButtonPressed = createStandardAction('controller/magicButtonPressed')<void>()